import Card from "../components/Card"

function NotFound() {
    const text: string = `It looks like the page you’re looking for doesn’t exist. \n But don’t worry, we’re here to help you get back on track!
    Why not head back to our homepage or explore some of the other 
    fantastic resources in our Kari IoT Library?`

    return (
        <div>
        <Card intro="Oops Page Not Found" data={text} text="Home" route="/"/>
        </div>
    )
}

export default NotFound
